import { combineReducers } from 'redux';
import { flip } from "containers/FlipMatch/reducers";
import globalNotifications from "containers/GlobalNotification/reducers";
import loaders from "components/Loader/reducers";

const rootReducer = combineReducers({
    flip,
    globalNotifications,
    loaders,
});
export default rootReducer;
